import { render, staticRenderFns } from "./WDMOTACard.vue?vue&type=template&id=27890dad&scoped=true&"
import script from "./WDMOTACard.vue?vue&type=script&lang=js&"
export * from "./WDMOTACard.vue?vue&type=script&lang=js&"
import style0 from "./WDMOTACard.vue?vue&type=style&index=0&id=27890dad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27890dad",
  null
  
)

export default component.exports